import { render, staticRenderFns } from "./AnuncieImovelView.vue?vue&type=template&id=510d7b04&"
import script from "./anuncie.js?vue&type=script&lang=js&"
export * from "./anuncie.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports